import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, ArrowRight } from "lucide-react";

export const SearchBar = ({ initial = "", onSearch, size = "lg" }) => {
  const [q, setQ] = useState(initial);
  const navigate = useNavigate();
  const submit = (e) => {
    e.preventDefault();
    if (onSearch) onSearch(q);
    else navigate(`/faqs?q=${encodeURIComponent(q)}`);
  };
  const big = size === "lg";
  return (
    <form onSubmit={submit} className="relative flex w-full" data-testid="faq-search-form">
      <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500 pointer-events-none" size={big ? 20 : 18} />
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search symptoms, codes, parts..."
        data-testid="faq-search-input"
        type="search"
        enterKeyHint="search"
        className={`w-full bg-[#13171F] border border-[#27303E] focus:border-amber-500 outline-none text-white placeholder:text-slate-500 rounded-sm transition-colors duration-200 [&::-webkit-search-cancel-button]:hidden ${big ? "h-14 sm:h-16 pl-12 sm:pl-14 pr-16 sm:pr-36 text-base sm:text-lg" : "h-12 pl-11 pr-14 sm:pr-28 text-base"}`}
      />
      <button
        type="submit"
        aria-label="Search"
        data-testid="faq-search-submit-btn"
        className={`absolute right-1.5 sm:right-2 top-1/2 -translate-y-1/2 inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 active:scale-95 text-[#0B0D10] font-display font-bold uppercase rounded-sm transition-colors duration-200 ${big ? "h-11 sm:h-12 w-12 sm:w-auto sm:px-5" : "h-9 w-10 sm:w-auto sm:px-4 text-sm"}`}
      >
        <span className="hidden sm:inline">Search</span> <ArrowRight size={16} />
      </button>
    </form>
  );
};
